import styled from 'styled-components';

export const ToneScoreCardWrapper = styled.div`
  padding: 8px 0px;
`;
